
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QueryService } from './query-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { getHttpHeader } from '../../utils/http-header.factory';


export class QueryGuidService<T> extends QueryService<T> {

  constructor(url: string, h: HttpClient) { 
    super(url, h);
  }

  public getByGuid(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<T>>{
    return this.http.get<ApiResponseModel<T>>(`${ api_domain_url }${ this.apiUrl }/${ guid }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
